import React, { useContext, useState, useEffect } from "react";
import GlobalContext from "../../context/GlobalContext";
import {  ClientContractComplete, LoadContract } from "../../utils/apiCalls";
import { getMonthDateYear, addDateDays } from "../../utils/addDays";
import ConfirmMessages from "../../utils/confirmMessages";
import { Popover, OverlayTrigger } from 'react-bootstrap';
import DOMPurify from 'isomorphic-dompurify';
import ReactCountryFlag from "react-country-flag";
import Message from "../../components/Message"; 
import ModalContract from "../../components/JobProposal/ClientContract";
import SendMessage from "../../components/Message/SendMessage";
import Feedback from "../../components/JobProposal/Feedback";
import TablePagination from "../../components/Table/TablePagination";
import tableHelper from "../../components/Table/tableHelper";
export default function Contract(props) {

    const gContext = useContext(GlobalContext);
    const s3URL = process.env.REACT_APP_AWS_S3_URL;
    const [errorMessage, setErrorMessage] = React.useState('');
    const [rowsContracts, setRowsContracts] = useState([]);
    const [id, setId] = useState(null);
    const [guid, setGuid] = useState(null);
    const [message, setMessage] = React.useState(false);
    const [contract, setContract] = useState({});
    const [contractmodalvisible, setContractmodalvisible] = useState(false);
    const [modalvisible, setmodalvisible] = useState(false);
    const [modalMessagevisible, setmodalMessagevisible] = useState(false);
    const [currentValue, setCurrentValue] = useState({ code: null, id: null });
    const [mode, setMode] = useState("");
    const [showScrollup, setShowScrollup] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [page, setPage] = useState(1);
    const [profileValues, setprofileValues] = useState(JSON.parse(gContext.userInfo.profileInfo));
    const { slice, range } = tableHelper(rowsContracts, page, gContext.paginationSize);
    function GetLength(detail) {
        return DOMPurify.sanitize(detail?.replaceAll("''", "'").replaceAll("<br>", "").replaceAll(`<p>`, ``).replaceAll(`</p>`, ``)).length;
    }

    const togglecontractmodal = (cguid,cid) => {       
        if (cguid && cid)
           setContractmodalvisible(!contractmodalvisible);
    };
    const togglemodal = () => {
        setmodalvisible(!modalvisible);
    };
    const toggleMessagemodal = () => {
        setmodalMessagevisible(!modalMessagevisible);
    };
    const contractStatusChange = (id, mode) => {
        setShowScrollup(document.documentElement.scrollTop);
        if (id) {

            gContext.setconfirmModal({ header: " ", ["text"]: "Do you want to " + mode + " this contract?", ["confirmed"]: false, code: mode, id: id, showButton: true, mode: 'post' });
            gContext.toggleConfirmModal();
        }
    }
   
    useEffect(() => {
        if (gContext.confirmModal.confirmed) {

            if (gContext.confirmModal.mode == "post") {

                UpdateStatus(gContext.confirmModal.code, gContext.confirmModal.id);
                gContext.setconfirmModal({
                    ...gContext.confirmModal, ["confirmed"]: false, ["id"]: null, ["code"]: null
                });

            }
            else
                setCurrentValue({ code: null, id: null });
        }
        else { setCurrentValue({ code: null, id: null }); }
    }, [gContext.confirmModal]);


    async function UpdateStatus(code, id) {
        try {
            if (code == "complete") {
               
                gContext.setLoaderModalVisible(true);
                const result = await ClientContractComplete();
                
                if (result.data.expertContractUpdate.responseData.code == "200") {
                    gContext.toggleRefreshDashboard("contract");
                    
                } gContext.setLoaderModalVisible(false);
            }
            if (code == "terminate") { }
        }
        catch (e) {
            console.log(e);
        }
       
    }


    function LoadContracts() {
        try {

            if (props.contractData) {
                setPage(1);
                let data;
                if (props.mode === "new") {

                    data = props.contractData.new;
                  
                     
                }
                else if (props.mode === "Active") {

                    data = props.contractData.active;
                 
                    
                }
                else if (props.mode === "Completed") {

                    data = props.contractData.completed;                 
                    
                }
                else {
                    data = props.contractData.terminated;
                                      
                }
                
 
                
                setRowsContracts(data);
                setLoaded(true);
            }
        } catch (e) { console.log(e); }
    }
    useEffect(() => {
        LoadContracts();
    }, [props.contractData]);

    useEffect(() => {
        
        LoadContracts();
    }, [props.mode]);
     

    useEffect(() => {
        LoadContracts();
        gContext.setLoaderModalVisible(false);
    }, []);
    async function contractComplete(data,mode)
    {
        try {
           
          
            setErrorMessage("");
           

            if (data.statuscode == 100) {
                 
                setId(data.id); setGuid(data.contractguid); setMode(mode); setContractmodalvisible(true);
                return;
            }
            gContext.setLoaderModalVisible(true);
            const result = await LoadContract(data.contractguid);
           
            if (result.data.loadContract && result.data.loadContract.responseData.code == "200") {

                let response = JSON.parse(result.data.loadContract.responseData.message);
                
                if (response.length > 0  ) {
                    
                    if (mode == "terminate") {

                        if (response[0].milestones.length == 0) {
                            
                            setId(data.id); setGuid(data.contractguid); setMode("terminate"); setContractmodalvisible(true);
                        }
                        else
                        {

                            let filteredData = response[0].milestones.filter(item => (item["mscode"] == 200 || item["mscode"] == 300 || item["mscode"] == 450));
                            if (filteredData.length > 0) {
                                setContractmodalvisible(false);
                                gContext.setconfirmModal({ header: " ", ["text"]: ConfirmMessages.contractTerminationAlert.replace("[DATE]", getMonthDateYear(new Date().toISOString())), ["confirmed"]: false, code: data.contractguid, id: data.id, page: "contract", showInfo: true, showButton: true, mode: 'post' });
                                gContext.toggleConfirmModal();
                            }
                            else {
                                setId(data.id); setGuid(data.contractguid); setMode("terminate"); setContractmodalvisible(true);
                            }
                        }
                    }
                    else {
                        //Client can complete Approved/PAyment completed contracts
                        let filteredData = response[0].milestones.filter(item => (data.mscode != 350 && data.mspaymentstatuscode != 400));

                        if (filteredData.length > 0) {
                            setContractmodalvisible(false);
                            setErrorMessage(ConfirmMessages.contractCompleteAlert);
                        }
                        else { 

                            setId(data.id); setGuid(data.contractguid); setMode("complete"); setContractmodalvisible(true);

                        }
                    }
                }
               
            }
            
            gContext.setLoaderModalVisible(false);
            setLoaded(true);
        }
        catch (e) {
            console.log(e);
            gContext.setLoaderModalVisible(false);
            //  window.location.href = "/error";
        }

        
    }
    useEffect(() => {
        if (errorMessage != "") {
            gContext.setErrorModal(errorMessage);
            gContext.toggleErrorModal();
        }
    }, [errorMessage]);
    useEffect(() => {
        if (gContext.confirmModal.confirmed) {

            if (gContext.confirmModal.mode == "post" && gContext.confirmModal.page== "contract") {

               
                setId(gContext.confirmModal.id); setGuid(gContext.confirmModal.code); setMode("terminate"); togglecontractmodal(gContext.confirmModal.code, gContext.confirmModal.id);
                gContext.setconfirmModal({
                    ...gContext.confirmModal, ["confirmed"]: false, ["id"]: null, ["code"]: null
                });

            }
            else
                setCurrentValue({ code: null, id: null });
        }
        else { setCurrentValue({ code: null, id: null }); }
    }, [gContext.confirmModal]);

    useEffect(() => {

        document.title = "Dashboard | Syncuppro";
    }, []);
    return (
        <>
           

                            {message && <div className="text-red">
                                <Message message="Job deleted successfully" />
                            </div>}
                        
            {(loaded && rowsContracts && rowsContracts.length == 0) && <div className="d-flex flex-column align-item-center justify-content-center">
                <span className="text-light-gray m-icon material-icons m-b-10">work</span>
                <span>No contract found</span>
            </div>}
            {(loaded && rowsContracts && rowsContracts.length > 0) &&
                <>

                <div className="accordion" id="accordionContracts">
                    {slice && slice.map((data, index) => {
                        
                        return (
                            <div className="accordion-wrapper accordion-dashboard" key={index} id={"contracts" + index} >
                                <a className={index == 0 ? "accordion-btn  p-5 " : "accordion-btn  p-5 collapsed m-t-10"} data-toggle="tooltip" title="Click to view contracts details" data-bs-toggle="collapse" href={"#accordion-contracts" + index} aria-expanded={index == 0 ? "true" : "false"} > <b>   {((props.mode == "new" || props.mode === "Active") && data.datemodified && (addDateDays(new Date(), -7) < new Date(data.datemodified))) ? <div className="d-flex justify-content-center align-items-center">   <img src="../images/new.PNG" className=" w-30 m-r-10" alt="" /> <span className="pointer"  >{data.title}</span></div> : <><span className="pointer" data-toggle="tooltip" title="Click to view contract details"  >{data.title}</span></>}</b>
                                    <span className="m-icon material-icons indicator show">expand_more</span>
                                    <span className="m-icon material-icons indicator hide">expand_less</span>
                                </a>
                                <div id={"accordion-contracts" + index} className={index == 0 ? "collapse show  " : "collapse  "} data-bs-parent="#accordionContracts"  >
                                    <div className="accordion-body card panel p-10 ">

                                        <div className="  m-b-20">
                                            <div className="row"  >

                                            
                                                    <div className="icon-frame d-flex m-r-5" data-toggle="tooltip" title="Click to view client details">
                                                        <div className="info-meta company pointer" onClick={(e) => { window.location.href = "/expert/" + data.expertsub; }}   >
                                                            <img className="m-r-10" id={"img" + index} onError={(img) => { img.target.src = '../images/user-default.png'; }} src={s3URL + data.avatar} alt={data.firstname + ' ' + data.lastname} />
                                                            <span className="one-line text-black "><b>{data.firstname + ' ' + data.lastname} </b>
                                                            </span>
                                                        </div>


                                                    </div>

                                                
                                                    <div className="company-post m-b-10 d-none">


                                                        <div className="d-flex flex-column m-l-30">

                                                            <div className="info-meta flag m-r-20">
                                                                <span className="text-theme m-icon material-icons m-r-5">location_on</span><span className="one-line text-black m-r-5">
                                                                    <span className={`    ${(data.city != null && data.city.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.city ? data.city.toLowerCase() : "" + ' '}</span>
                                                                    {''}    <span className={`    ${(data.state != null && data.state.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.state ? data.state.toLowerCase() : ""}</span>{' ' + data.countrycode}</span>

                                                                <ReactCountryFlag
                                                                    countryCode={(data.countrycode) ? data.countrycode : ''}
                                                                    svg
                                                                    style={{
                                                                        width: '1em',
                                                                        height: '.7em',
                                                                    }}
                                                                    title={(data.countryname) ? data.countryname : ''}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                

                                                <div className="col-lg-12  col-md-12 col-sm-12  m-t-10 "  >
                                                    {data.desc &&
                                                        <div className=" heading-default-color m-b-10 pointer" onClick={() => { setId(data.id); setGuid(data.contractguid); setMode("view"); setContract(data); togglecontractmodal(data.contractguid, data.id); }} dangerouslySetInnerHTML={{ __html: (GetLength(data.desc) > 350 ? DOMPurify.sanitize((data.desc.replaceAll("''", "'").replaceAll("<br>", "").replaceAll("<br/>", "").replaceAll(`<p>`, ``).replaceAll(`</p>`, ``))).slice(0, 350) + " ...  " : DOMPurify.sanitize((data.desc.replaceAll("''", "'").replaceAll("<br>", "").replaceAll("<br/>", "").replaceAll(`<p>`, ``).replaceAll(`</p>`, ``)))) }}></div>
                                                    } </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                    <span className="text-theme m-icon material-icons f-20 m-r-5">monitor</span>  <span  ><b>Status :</b>   {data.status} </span>
                                                </div></div>
                                                
                                                <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                    <span className="text-theme m-icon material-icons f-20 m-r-5">attach_money</span>  <span  ><b>   Rate (USD) : </b>  ${(data.dailyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.dailyrate)) : ((data.fixedrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.fixedrate)) : (data.hourlyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.hourlyrate)) : (data.ratefrom && data.rateto) ? new Intl.NumberFormat('en-US').format(parseInt(data.ratefrom)) + ' - ' + new Intl.NumberFormat('en-US').format(parseInt(data.rateto)) : '-')} </span>
                                                </div></div>

                                                {(props.mode == "Active" || props.mode == "Completed") && <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                    <span className="text-theme m-icon material-icons f-20 m-r-5">work</span>  <span  ><b>Hours Spent : </b>   {data.totalhoursspent ? (data.totalhoursspent) : " - "} </span>
                                                </div></div>}

                                                {(props.mode == "new" || props.mode == "Active") && <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                    <span className="text-theme m-icon material-icons f-20 m-r-5">work</span>  <span  ><b>Weekly Hours :</b>    {data.hours ? (data.hours) : " - "}</span>
                                                </div></div>}

                                               
                                                {props.mode == "Active" && <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                    <span className="text-theme m-icon material-icons f-20 m-r-5">timer</span>   <span  ><b>Accepted on :</b>    {(data.accepteddate) ? getMonthDateYear(data.accepteddate) : " - "}</span>
                                                </div></div>}

                                                {(props.mode == "Active" || props.mode == "Completed" || props.mode == "Terminated") ?
                                                    <>   <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                        <span className="text-theme m-icon material-icons f-20 m-r-5">timer</span>   <b>Started on : </b>     <span className="  d-flex  align-item-center justify-content-center m-l-5"> {data.startdate ? getMonthDateYear(data.startdate) : " - "} {props.mode == "new" && <OverlayTrigger trigger="hover" placement="auto" overlay={<Popover className="" >

                                                            <div className="tooltip-header bg-gray">
                                                                <h5>Information</h5>
                                                            </div>
                                                            <div className="tooltip-meta">
                                                                <p>Message expert before expiry date {data.datecreated ? getMonthDateYear(addDateDays(data.datecreated, 14).toISOString()) : ""} </p>

                                                            </div>
                                                        </Popover>} ><span className="text-theme m-icon material-icons m-l-5 pointer"  >info</span></OverlayTrigger>}</span> 
                                                    </div></div></> : <> <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                        <span className="text-theme m-icon material-icons f-20 m-r-5">timer</span>    <b>Starts on : </b>  <span className="  d-flex  align-item-center justify-content-center m-l-5"> {data.startdate ? getMonthDateYear(data.startdate) : ""} {props.mode == "new" && <OverlayTrigger trigger="hover" placement="auto" overlay={<Popover className="" >

                                                            <div className="tooltip-header bg-gray">
                                                                <h5>Information</h5>
                                                            </div>
                                                            <div className="tooltip-meta">
                                                                <p>Message expert before expiry date {data.datecreated ? getMonthDateYear(addDateDays(data.datecreated, 14).toISOString()) : ""} </p>

                                                            </div>
                                                        </Popover>} ><span className="text-theme m-icon material-icons m-l-5 pointer f-20"  >info</span></OverlayTrigger>}</span>
                                                    </div></div></>}

                                                {props.mode == "Completed" && <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                    <span className="text-theme m-icon material-icons f-20 m-r-5">timer</span>   <span  ><b>Completed on :</b>   {data.completeddate ? getMonthDateYear(data.completeddate) : ""}</span>
                                                </div></div>}                                             


                                                {(props.mode == "Terminated") && <>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                        <span className="text-theme m-icon material-icons f-20 m-r-5">person</span>  <span  ><b>  Terminated by :</b>     {data.terminateperson ? data.terminateperson : " - "}   </span>
                                                    </div></div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                        <span className="text-theme m-icon material-icons f-20 m-r-5">timer</span> <span  ><b>  Terminated on :</b>       {data.terminateddate ? getMonthDateYear(data.terminateddate) : " - "}  </span>
                                                    </div></div>
                                                    <div className="col-lg-12 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                        <span  ><b>  Terminated Reason :</b>  {(data.reason) ? data.reason : " - "}  </span>
                                                    </div></div></>
                                                   }

                                            </div>
                                            <div className="d-flex m-t-15 action-btns">
                                                {props.mode == "new" && <button className="btn btn-sm btn-green pointer m-r-10" onClick={() => { window.location.href = "/contract/" + data.contractguid; }}>
                                                    View Contract
                                                </button>}
                                                {props.mode == "Active" && <button className="btn btn-sm btn-green pointer m-r-10" onClick={() => { window.location.href = "/contract/" + data.contractguid; }}>
                                                    Manage Contract
                                                </button>}
                                                {(props.mode != "Active" && props.mode != "new") && <button className="btn btn-sm btn-green pointer m-r-10" onClick={() => { window.location.href = "/contract/" + data.contractguid; }}>
                                                    View
                                                </button>}
                                                {props.mode == "new" &&

                                                    <>  <button className="btn btn-sm btn-green m-r-10" onClick={() => { setContract(data); toggleMessagemodal(); }}>
                                                        Message</button>

                                                    <button className="btn btn-sm btn-green m-r-10" onClick={() => { setId(data.id); setGuid(data.contractguid); setMode("edit"); togglecontractmodal(data.contractguid,data.id); }}>Edit</button>
                                                    </>}


                                                {(props.mode == "Terminated") &&
                                                    <button className="btn btn-sm btn-green m-r-10" onClick={() => { setContract(data); togglemodal(); }}>
                                                        Feedback</button>

                                                }
                                                {props.mode == "Active" &&
                                                    <button className="btn btn-sm btn-green m-r-10" onClick={() => {   contractComplete(data, 'complete'); }}>
                                                        Complete</button>
                                                }
                                                {(props.mode == "new" || props.mode == "Active") && profileValues && profileValues.length > 0 && !profileValues[0].flagged &&


                                                    <button className="btn btn-sm btn-orange m-r-10" onClick={() => {  contractComplete(data, 'terminate'); }}>
                                                        Terminate</button>
                                                }


                                            </div>
                                            <div className="expert-link d-flex justify-content-end">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>)
                    })}
                </div>

                <div className="table-responsive d-none">
                    <table className="table table-striped d-none">
                        <thead>

                            <tr><th></th>
                                <th className="w-200   min-lg-cell" > Title</th>
                                <th className="  min-lg-cell">   Applicant</th>

                                <th className="  min-lg-cell"> Rate </th>

                                {(props.mode == "Active" || props.mode == "Completed" ) && 
                                <>  <th className="  min-lg-cell" >Hours Spent</th> </>}


                                
                                {props.mode == "new"  || props.mode == "Active" ? <> <th className="  min-lg-cell"> Weekly Hours</th>   
                                </>:''}
                                

                                {props.mode == "Active" && <> <th className="  min-lg-cell"> Accepted on</th>   
                                </>}
                                
                                {(props.mode == "Active" || props.mode == "Completed" || props.mode == "Terminated") ?
                                <>  <th className="  min-lg-cell" >Started on</th></>: <> <th className="  min-lg-cell" >Starts On</th></>}
                               
                                
                               
                               
                                {props.mode == "Completed" && <> <th className="  min-lg-cell">Completed on</th>
                                </>}
                                {props.mode == "Terminated" && <>
                                    {props.mode == "Terminated" && <th className="  min-lg-cell">
                                        Termination  Reason
                        </th>}
                                    <th className="  min-lg-cell"
                                     
                                >
                                    Terminated by
                        </th>

                                    <th 
                                        className="  min-lg-cell"
                                    >
                                        Terminated on
                        </th>
                                     
                                </>}
                                <th></th>
                            </tr>
                             
                        </thead>
                        <tbody>
                            {slice && slice.map((data, index) => {
                                

                                return (
                                    <tr key={index}>
                                        <td className="m-0 p-0">  {((props.mode == "new" || props.mode === "Active") && data.datemodified && (addDateDays(new Date(), -7) < new Date(data.datemodified))) && <div className="d-flex justify-content-center align-items-center w-30">   <img src="../images/new.PNG" alt="" /></div>}</td>
                                        <td >
                                            <span className="d-flex justify-content-left align-items-left">
                                                <span className="title one-line pointer justify-content-left align-items-left" data-toggle="tooltip" title={data.title} onClick={() => { setId(data.id); setGuid(data.contractguid); setMode("view"); togglecontractmodal(data.contractguid,data.id); }}>{data.title}</span> 
                                            </span>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <div className="info-meta company pointer" onClick={(e) => { window.location.href = "/expert/" + data.sub; }}   >
                                                    <img className="m-r-10 " id={ "img"+index} src={s3URL + data.avatar} alt={data.firstname + ' ' + data.lastname} onError={(img) => { img.target.src = '../images/user-default.png'; }} />
                                                    <span className="one-line text-black ">{data.firstname + ' ' + data.lastname} </span> 
                                                </div>

                                               
                                            </div>
                                        </td>
                                        <td>${(data.dailyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.dailyrate)) : ((data.fixedrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.fixedrate)) : (data.hourlyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.hourlyrate)) : (data.ratefrom && data.rateto) ? new Intl.NumberFormat('en-US').format(parseInt(data.ratefrom)) + ' - ' + new Intl.NumberFormat('en-US').format(parseInt(data.rateto)) : '-')}</td>
                                        

                                        {(props.mode == "Active" || props.mode == "Completed" ) && <> 
                                         <td  >
                                             
                                            {data.totalhoursspent ? (data.totalhoursspent):""}
                                             
                                        </td></>}
                                        
                                        {(props.mode == "new" || props.mode == "Active" ) && <> 
                                         <td  >
                                             
                                            {data.hours ? (data.hours):""}
                                             
                                        </td></>}


                                        {props.mode == "Active" && <><td >
                                               
                                                    {(data.accepteddate) ? getMonthDateYear(data.accepteddate) : ""}
                                                
                                            </td>
                                        </>}


                                        {(props.mode == "new" || props.mode == "Active" || props.mode == "Completed" || props.mode == "Terminated") &&
                                            <>   <td className="">

                                            <span className="  d-flex  align-item-center justify-content-center"> {data.startdate ? getMonthDateYear(data.startdate) : ""} {props.mode == "new" && <OverlayTrigger trigger="hover" placement="auto" overlay={<Popover className="" >

                                                <div className="tooltip-header bg-gray">
                                                    <h5>Information</h5>
                                                </div>
                                                <div className="tooltip-meta">
                                                    <p>Message expert before expiry date {data.datecreated ? getMonthDateYear(addDateDays(data.datecreated, 14).toISOString()) : ""} </p>

                                                </div>
                                            </Popover>} ><span className="text-theme m-icon material-icons m-l-5 pointer"  >info</span></OverlayTrigger>}</span>
                                 
                            </td></>}

                            {props.mode == "Completed" && <> <td>
                                           
                                           {data.completeddate ? getMonthDateYear(data.completeddate) : ""}
                                       
                                   </td>
                                   </>}

                                   {props.mode == "Terminated" && <>
                                            <td  
                                            >
                                                {(data.reason) ?  data.reason : ""}
                                            </td>
                                            <td  >
                                                
                                                    {data.terminateperson}
                                                
                                            </td>
                                            <td >
                                                
                                                    {data.terminateddate ? getMonthDateYear(data.terminateddate) : ""}
                                                
                                            </td>
                                            
                                        </>}
                               
                                       

                                       


                                      
                                       
                                       

                                        

                                       
                                        
                                       


                                       
                                        <td>
                                            <div className="btn-table">
                                                {props.mode == "new" && <button className="btn btn-sm btn-gray pointer" onClick={() => { window.location.href = "/contract/" + data.contractguid ; }}>
                                                    View Contract
                                                </button>}
                                            {props.mode == "Active" && <button className="btn btn-sm btn-gray pointer" onClick={() => { window.location.href = "/contract/" + data.contractguid; }}>
                                                    Manage Contract
                                                </button>}
                                        {(props.mode != "Active" && props.mode != "new") && <button className="btn btn-sm btn-gray pointer" onClick={() => { window.location.href = "/contract/" + data.contractguid; }}>
                                                    View
                                                </button>}
                                                {props.mode == "new" &&

                                              <>  <button className="btn btn-sm btn-gray" onClick={() => { setContract(data); toggleMessagemodal(); }}>
                                                            Message</button>

                                                    <button className="btn btn-sm btn-gray" onClick={() => { setContract(data); setId(data.id); setGuid(data.contractguid); setMode("edit"); togglecontractmodal(data.contractguid,data.id); }}>Edit</button>
                                                </>   }


                                                {(props.mode == "Terminated") && 
                                                    <button className="btn btn-sm btn-gray"  onClick={() => { setContract(data); togglemodal(); }}>
                                                        Feedback</button>

                                                    }
                                                {props.mode == "Active" &&
                                                    <button className="btn btn-sm btn-gray" onClick={() => { setContract(data); contractComplete(data,'complete'); }}>
                                                    Complete</button>
                                                     }
                                                {(props.mode == "new" || props.mode == "Active") &&  profileValues && profileValues.length > 0 && !profileValues[0].flagged && 


                                                    <button className="btn btn-sm btn-gray" onClick={() => { setContract(data); contractComplete(data, 'terminate');  }}>
                                                    Terminate</button>
                                                   }
 
                                            </div>
                                        </td>
                                    </tr>)
                            })}</tbody>
                    </table>
                </div>
                {(rowsContracts && rowsContracts.length > 5) &&
                    <TablePagination range={range} slice={slice} setPage={setPage} page={page} />}
                </>}
            {modalMessagevisible && <SendMessage userdata={contract} modalvisible={modalMessagevisible} togglemodal={toggleMessagemodal} />}
            {modalvisible && <Feedback contract={contract} modalvisible={modalvisible} togglemodal={togglemodal} />}
            {contractmodalvisible && <ModalContract contract={contract} guid={guid} id={id} mode={mode} cmode={props.mode} contractmodalvisible={contractmodalvisible} contractOperation={(cdata,cmode) => {  contractComplete(cdata, cmode);   } } togglemodal={() => togglemodal()} togglecontractmodal={() => { togglecontractmodal(guid, id); }} toggleEditmode={() => { setMode("edit");   }} updateData={() => LoadContracts()} openMessagemodal={() => { toggleMessagemodal(); }} profileValues={profileValues} />}
        </>
    );
};